import AuthApi from '~/api/auth'
import EventBus from '@/plugins/eventbus'
import Representatives from '~/api/representatives'

const storedAuth = localStorage.getItem('user');
let resumeAuthentication = false;
let resumeUser = null;

if (storedAuth) {
    resumeAuthentication = true;

    try {
        resumeUser = JSON.parse(storedAuth);
    } catch (e) {
        resumeAuthentication = false;
    }
}

export default {
    // Authentication status
    authenticated: resumeAuthentication,

    // Current user
    user: resumeUser,

    fetchUser() {
        Representatives.get(this.user.id).then(res => {
            const user = res.data;
            this.user.firstname = user.firstname;
            this.user.lastname = user.lastname;
            this.user.avatar_id = user.avatar_id;
            localStorage.setItem('user', JSON.stringify(this.user));
            EventBus.$emit('avatar-changed');
            EventBus.$emit('lang-changed');
        })
    },
    login(username, password) {
        return new Promise((resolve, reject) => {
            AuthApi.login(username, password).then(res => {
                const user = res.data;
                localStorage.setItem('user', JSON.stringify(user));
                this.authenticated = true;
                this.user = user;
                EventBus.$emit('user-changed');
                EventBus.$emit('user-changed2');
                EventBus.$emit('avatar-changed');
                resolve(user);
            }, e => {
                reject(e);
            })
        })
    },
    logout() {
        AuthApi.logout().then(() => {
            this.localLogout();
        }, () => {
            this.localLogout();
        })
    },
    localLogout() {
        localStorage.removeItem('user');
        this.authenticated = false;
        this.user = null;
        EventBus.$emit('user-changed');
        EventBus.$emit('user-changed2');
        EventBus.$emit('avatar-changed');
    }
}